const state = {
    loading: false
};

const mutations = {
    SHOW_LOADING(state) {
        state.loading = true;
    },
    HIDE_LOADING(state) {
        state.loading = false;
    }
};

const actions = {
    showLoading({ commit }) {
        commit("SHOW_LOADING");
    },
    hideLoading({ commit }) {
        commit("HIDE_LOADING");
    }
};

const getters = {
    isLoading: (state) => {
        console.log("📡 [Vuex] isLoading getter 访问，当前值 =", state.loading);
        return state.loading;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};